import { createContext } from "react";
const PageFacultyMonitoringContext = createContext();
export default PageFacultyMonitoringContext;
